import { render } from "./RecaptchaCheckbox.vue?vue&type=template&id=fdada842&scoped=true"
import script from "./RecaptchaCheckbox.vue?vue&type=script&lang=js"
export * from "./RecaptchaCheckbox.vue?vue&type=script&lang=js"

import "./RecaptchaCheckbox.vue?vue&type=style&index=0&id=fdada842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdada842"]])

export default __exports__